import React, { useState } from "react";
import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AFFILIATE_CONSTANTS } from "../../sharedfiles/Constants";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Button } from "../../ui/button";
import {
  getDateTimeFormate,
  getFromLocalStorage,
  formatMoney,
  getUTCDate,
  MomentUTCDateTimeToday,
  MomentUTCDateTimeEnd,
  getConvertedAmountWithCurrency,
} from "../../sharedfiles/helper";
import { exportPDFC } from "../../sharedfiles/pdfExport";
import Vpagination from "../../sharedfiles/Vpagination";
import {
  AddCampaign,
  listCampaigns,
  setIsToShow,
  setItems,
  setPage,
  setVisibleRecords,
  setDocsData_campaign,
  setCampaignField,
  setCampaignDateFilters,
} from "../Affiliate/AffiliateSlice";
import Input from "../Common/inputs/Input";
import CampaignTable from "./CampaignTable";

import { affiliateDates } from "../Common/data/mapData";
import { DatePicker as Datepicker } from "../../ui/date-picker";

function Campaign(props) {
  const dispatch = useDispatch();
  const campaignList = useSelector(
    (st) => st.affiliateSlice.campaignList?.data
  );
  const viewOnlyuser = useSelector((state) => state.dashboard.viewOnlyuser)
  const campaignDateFilters = useSelector((st) => st.affiliateSlice.campaignDateFilters) || {};
  // Restores the Campaign Name field and date filters after switching tabs
  // away and back (this page fully unmounts/remounts on tab switch) - read
  // once here and used only as lazy useState initializers below, so the very
  // first render already matches.
  const [campaign, setCampaign] = useState(() => props.campaignField?.value ?? "");
  const [capmaignErr, setCapmaignErr] = useState(() => props.campaignField?.error ?? false);
  const [tableData, setTableData] = useState([]);
  const [pdfBody, setPdfBody] = useState([]);
  const [dateFields, setDateFields] = useState(() => ({
    regDateFrom: campaignDateFilters.regDateFrom ?? '',
    regDateTo: campaignDateFilters.regDateTo ?? '',
  }))
  const [dateErr, setDateErr] = useState("")
  const [dateToErr, setDateToErr] = useState("")
  const [hasSearched, setHasSearched] = useState(() => campaignDateFilters.hasSearched ?? false)

  const platformId = useSelector(st => st.affiliateSlice.selected_AffiliateId);
  const userId = platformId || getFromLocalStorage("AffliateUserId");
  const headers = [
    "Id",
    "Campaign Name",
    // "AffiliateId",
    "Created Date",
    "Updated Date",
    // "View Campaign",
    "Total Registrations",
    "Deposited Customers",
    "Total Deposits",
    "New Customers",
    "Total Stakes",
    "Total Payout",
    "GGR",
    "Total Bonus Amount",
    "Total Number of Bets",
    "Total Withdrawals",
    "URL Hits Count",
  ];
  const filedsHandler = (e) => {
    const { name, value } = e.target;
    const campaignErr = value === "";
    setCampaign(value);
    setCapmaignErr(campaignErr);
    dispatch(setCampaignField({ value: value, error: campaignErr }));
  };
  const submit = (e) => {
    e.preventDefault();
    const payload = {
      userId: userId,
      body: { campaignName: campaign },
    };
    const isValid = campaign === "" ? true : false;
    setCapmaignErr(isValid);
    dispatch(setCampaignField({ value: campaign, error: isValid }))
    if (!isValid && userId) {
      dispatch(AddCampaign(payload));
      setTimeout(() => {
        dispatch(listCampaigns(userId, 0, 25, {}));
        // callApi(1, 25, userId);
        setCampaign("");
        dispatch(setCampaignField({ value: "", error: false }));
      }, 500);
    }
  };

  const exportPDF = () => {
    const title = "Campaign Report";
    exportPDFC(title, [headers], pdfBody);
  };

  function callApi(page, items, id) {
    dispatch(setIsToShow(false));
    dispatch(listCampaigns(id, page - 1, items, {}));
  };

  useEffect(() => {
    const dataExist = Object.keys(props?.campaignList).length > 0 && props.campaignList?.data?.length > 0
    if (!dataExist) {
      // callApi(1, 25, userId);
      dispatch(listCampaigns(userId, 0, 25, {}));


    } else {
      const csvDataExist = props?.docsData_campaign && Array.isArray(props.docsData_campaign) && props.docsData_campaign.length > 0
      let pdfData = [];
      if (csvDataExist) {
        pdfData = props?.docsData_campaign.slice(1, props?.docsData_campaign?.length);
      }
      setTableData(props.docsData_campaign);
      setPdfBody(pdfData);
    }
  }, []);

  // Mirrors the date filters + search-visibility into redux on every change,
  // so they survive this page unmounting/remounting on tab switch.
  useEffect(() => {
    dispatch(setCampaignDateFilters({ ...dateFields, hasSearched }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateFields, hasSearched]);
  const updateTableData = () => {
    let tbData = [];
    if (Array.isArray(campaignList) && campaignList.length > 0) {
      const data = campaignList && campaignList.map((item) => [
        item.id,
        item.name,
        // item.affiliateId,
        item.createdDate ? getDateTimeFormate(item.createdDate) : "-",
        item.updatedDate ? getDateTimeFormate(item.updatedDate) : "-",
        item.totalRegistration,
        item.depositedCustomers,
        getConvertedAmountWithCurrency(item.totalDeposit, item.currencyCode || item.currency, item.baseCurrencyRate),
        item.newCustomers,
        getConvertedAmountWithCurrency(item.totalStake, item.currencyCode || item.currency, item.baseCurrencyRate),
        getConvertedAmountWithCurrency(item.totalPayout, item.currencyCode || item.currency, item.baseCurrencyRate),
        getConvertedAmountWithCurrency(item.totalGgr, item.currencyCode || item.currency, item.baseCurrencyRate),
        item.totalBonus,
        item.betCount,
        getConvertedAmountWithCurrency(item.totalWithdraw, item.currencyCode || item.currency, item.baseCurrencyRate),
        item.campaignClickCount,
      ]);
      const tbData = [headers, ...data]
      setPdfBody(data);
      setTableData(tbData);
      dispatch(setDocsData_campaign(tbData))
    }
  };
  useEffect(() => {
    campaignList && updateTableData();
  }, [campaignList]);

  const setDateHandler = (value, name) => {
    setDateFields((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
    if (name === "regDateFrom") {
      if (value) setDateErr('');
    }
    if (name === "regDateTo") {
      if (value) setDateToErr('');
    }
  }

  const onSearch = () => {
    const fromMissing = !dateFields.regDateFrom;
    const toMissing = !dateFields.regDateTo;
    if (fromMissing) setDateErr("Start Date is required");
    else setDateErr('');
    if (toMissing) setDateToErr("End Date is required");
    else setDateToErr('');
    if (fromMissing || toMissing) return;

    const payload = {
      endDate: MomentUTCDateTimeEnd(dateFields.regDateTo),
      startDate: MomentUTCDateTimeToday(dateFields.regDateFrom)
    }
    setHasSearched(true);
    dispatch(listCampaigns(userId, 0, 25, payload));
  }
  const onResetBtn = () => {
    setDateFields({ regDateFrom: '', regDateTo: '' })
    setDateErr('')
    setDateToErr('')
    setHasSearched(false)
  }

  return (
    <React.Fragment>
      <div className='space-y-6'>

        {/* Add Campaign Section */}
        <Card>
          <CardHeader className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-700">
            <CardTitle>Add New Campaign</CardTitle>
            <p className="text-sm text-muted-foreground mt-1">
              Create a new marketing campaign for tracking affiliate performance
            </p>
          </CardHeader>
          <CardContent className="pt-6">
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4'>
              <Input
                title={"Campaign Name"}
                name={"campaign"}
                ids={"campaign"}
                value={campaign}
                placeholder={"Campaign Name"}
                setValue={(e) => filedsHandler(e)}
                errorMsg={capmaignErr && "Campaign Name is required"}
                info={"Provide Campaign Name"}
                show={true}
              />
            </div>
            <div className='pt-6 mt-6 border-t bg-muted -mx-6 -mb-6 px-6 pb-6'>
              <div className='flex justify-center gap-3'>
              <Button
                onClick={(e) => submit(e)}
                type={"button"}
                id={"addCampaign"}
                variant="default"
                disabled={viewOnlyuser}
              >
                {AFFILIATE_CONSTANTS.addCampaign}
              </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Filter Campaigns & Campaigns List */}
        <Card>
          <CardHeader className="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-gray-800 dark:to-gray-700">
            <CardTitle>Filter Campaigns</CardTitle>
            <p className="text-sm text-muted-foreground mt-1">
              Filter and view campaign performance metrics
            </p>
          </CardHeader>
          <CardContent className="pt-6">
            <div className='flex flex-wrap items-start gap-4'>
              {affiliateDates.map((item, ind) => {
                const minDate = [null, dateFields.regDateFrom];
                const max = dateFields.regDateTo ? dateFields.regDateTo : new Date();
                const maxDate = [max, new Date()];
                const values = [dateFields.regDateFrom, dateFields.regDateTo];
                return (
                  <div key={ind} className='flex-1 min-w-[160px]'>
                    <Datepicker
                      title={item.title}
                      name={item.name}
                      value={values[ind]}
                      setValue={(date, value) => setDateHandler(date, value)}
                      errorMsg={ind === 0 ? dateErr : dateToErr}
                      minDate={minDate[ind]}
                      maxDate={maxDate[ind]}
                      ids={item.ids}
                      info={item.info}
                    />
                  </div>
                );
              })}
              <div className='flex gap-2 mt-7'>
                <Button onClick={(e) => onSearch(e)} id="searchCampaign">
                  Search
                </Button>
                <Button onClick={(e) => onResetBtn(e)} variant="outline" id="campaignReset">
                  Reset
                </Button>
              </div>
            </div>
          </CardContent>
          {hasSearched && (<div className='border-t'>
            <CardContent className="pt-6 space-y-4">
            {Array.isArray(campaignList) && campaignList.length > 0 && (
              <Vpagination
                data={campaignList}
                totalRecords={props.campaignList?.totalRecords}
                paginationFirstValue={props.page}
                paginationSecondValue={props.items}
                setPaginationFirstValue={setPage}
                setPaginationSecondValue={setItems}
                recordsShow={props.visibleRecords}
                setRecordsShow={setVisibleRecords}
                isVisible={props.isToShow}
                setIsVisible={setIsToShow}
                csvData={tableData}
                exportPDF={exportPDF}
                payloadData={userId}
                callApi={callApi}
                csvFileName={"Campaign Report"}
              />
            )}
            <CampaignTable data={campaignList} viewTable={props.isToShow} />
          </CardContent>
          </div>)}
        </Card>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    campaignList: state.affiliateSlice.campaignList,
    page: state.affiliateSlice.page,
    items: state.affiliateSlice.items,
    visibleRecords: state.affiliateSlice.visibleRecords,
    isToShow: state.affiliateSlice.isToShow,
    docsData_campaign: state.affiliateSlice.docsData_campaign,
    campaignField: state.affiliateSlice.campaignField
  };
};

export default connect(mapStateToProps)(Campaign);